<template>
	<div class="content">
		<div class="section">
			<div class="tag flex-row">
					<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>订单信息</span></div>
			</div>
			<div class="info">
				<div class="data">
					订单编号：SK23031601105888
				</div>
				<div class="data">
					入馆日期：2023-03-17 09:00-10:00
				</div>
				<div class="data flex-row" v-if="false">
					订单状态：<span style="color: #E34D59; font-weight: 600;">已退款</span>
				</div>
				<div class="data flex-row">
					订单状态：<span style="color: #E34D59; font-weight: 600;">已取消</span> <div class="tip">
						订单超时，未支付
					</div>
				</div>
				<div class="data flex-row" v-if="false">
					订单状态：<span style="color: #BB2916; font-weight: 600;">已使用</span>
				</div>
				<div class="data">
					订单金额：
					<span class="price" style="color: #37695C;">￥60</span>
					<span style="color:#E34D59;font-weight: 600;" v-if="false">（已原路返还）</span>
				</div>
			</div>
			<div class="table">
				<div class="tableHeader flex-row">
					<div class="item">
						姓名
					</div>
					<div class="item">
						证件类型
					</div>
					<div class="item idCard">
						证件号码
					</div>
					<div class="item">
						门票名称
					</div>
					<div class="item">
						票价
					</div>
				</div>
				<div class="tBody">
					<div class="th flex-row" v-for="(item,index) in list" :key="index">
						<div class="data">
							王五
						</div>
						<div class="data">
							身份证
						</div>
						<div class="data">
							244************488
						</div>
						<div class="data flex-row" v-if="index!=1&&index!=2">
							普通票 <span>已使用</span>
						</div>
						<div class="data flex-row" v-if="index==2">
							普通票 <span style="background: #E34D59;">已取消</span>
						</div>
						<div class="data flex-row" v-if="index==1">
							普通票 <span style="background: #E34D59;">已退款</span>
						</div>
						<div class="data" v-if="index!=1">
							￥25
						</div>
						<div class="data" style="color: #E34D59;" v-if="index==1">
							￥-25
						</div>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
						<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>门票二维码</span></div>
			
			</div>
			<div class="QR">
				<div class="status flex-row">
					<img src='../../assets/img/icon-choose.svg'>
					出票成功！
				</div>
				动态二维码门票将以短信形式发送至您的手机，或直接进入购票小程序-订单详情页查看二维码门票，或直接刷身份证入馆参观。
			</div>
			<div class="tag flex-row">
							<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>支付方式</span></div>
	
			</div>
			<div class="paymode flex-row">
				<div class="item flex-row">
					<img src='../../assets/img/icon-juhe.png'> 聚合支付
				</div>
			</div>
			<div class="tag flex-row">
				<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>温馨提示</span></div>
			</div>
			<div class="detail">
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					请携带身份证，于约定日期刷证或者凭借二维码核销入馆
				</div>
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					门票如未使用，请在参观日23:00前退票，超过时限则无法退票
				</div>
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					支付完成后如需在PC端查询门票，可到【订单查询】进行查询搜索
				</div>
			</div>
			<img class="line" src='../../assets/img/icon-line.svg'>
			<div class="btnbox flex-row">
				<router-link to="/">
					<div class="prevbtn cursorp">
						返回
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Used',
		data() {
			return {
				list: [1, 2, 3, 4],
				radio: ''
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		margin: auto;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
	}

	.section {
		width: 100%;
	}

	.section .info {
		width: 1007px;
		margin-left: 60px;
		margin-bottom: 8px;
		position: relative;
	}

	.section .info .data {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 20px;
	}

	.info .tip {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #BB2916;
		height: 24px;
		background: #E1FEF7;
		border-radius: 12px;
		border: 1px solid #BB2916;
		line-height: 24px;
		margin-left: 10px;
		padding: 0 6px;
		box-sizing: border-box;
	}

	.info .price {
		font-size: 20px;
		font-weight: 600;
	}

	.section .table {
		width: 1007px;
		padding: 0 60px;
		box-sizing: border-box;
		margin-bottom: 24px;
	}

	.table .tableHeader {
		width: 1007px;
		height: 64px;
		border-radius: 6px 6px 0px 0px;
		background-image: url('../../assets/img/tableBG.svg');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		justify-content: space-between;
	}

	.table .tableHeader .item {
		font-size: 16px;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		width: 201px;
		text-align: center;
	}

	.table .tBody {
		width: 1007px;
		border: 1px solid #F1F1F1;
	}

	.table .tBody .th {
		width: 100%;
		height: 63px;
		justify-content: space-between;
		border-bottom: 1px solid #F1F1F1;
	}

	.table .tBody .th:last-child {
		border: none !important;
	}

	.tBody .data span {
		display: block;
		width: 60px;
		height: 23px;
		background: #BB2916;
		border-radius: 6px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-left: 7px;
		line-height: 23px;
	}

	.tBody .th .data {
		font-size: 16px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		width: 201px;
		text-align: center;
		padding: 0 6px;
		box-sizing: border-box;
		justify-content: center;
	}


	.section .QR {
		width: 1007px;
		height: 114px;
		padding: 0 24px;
		box-sizing: border-box;
		background: #EBF8F1;
		border: 1px solid #BB2916;
		margin-left: 60px;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 24px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.section .QR .status {
		font-size: 18px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 10px;
	}

	.QR .status img {
		width: 34px;
		height: 34px;
		margin-right: 8px;
	}

	.section .paymode {
		padding: 0 60px;
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 24px;
	}

	.section .paymode .item {
		margin-right: 16px;
		color: #000000;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
	}

	.section .paymode .item img {
		width: 48px;
		height: 48px;
		margin-right: 14px;
	}

	.section .detail {
		margin: 24px 0;
		margin-left: 60px;
	}

	.detail .item {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 20px;
	}

	.detail .item img {
		width: 14px;
		height: 14px;
		margin-right: 4px;
	}

	.line {
		width: 1038px;
		height: 6px;
		margin: 24px 0;
		margin-left: 60px;
	}

	.btnbox {
		justify-content: center;
	}

	.btnbox div {
		width: 324px;
		height: 60px;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		text-align: center;
		line-height: 60px;
		border-radius: 30px;
	}

	.btnbox .backbtn {
		color: #3A6E61;
		background: #FFFFFF;
		border: 1px solid #3A6E61;
		margin-right: 32px;
	}

	.btnbox .prevbtn {
		color: #FFFFFF;
		background: #BB2916;
	}
</style>